import { Injectable } from '@angular/core';

@Injectable({providedIn: "root"})
export class ArrayHelperService {

    /**
     * Chunck an Array into small parts.
     * Those parts can be used to populate a mat-table progressively
     */
    public chunkArray(arr: any[], chunkLength: number = 5): any[]{

        const chunks = arr.reduce((resultArray: any[], item: any, index: number) => {
            const chunkIndex: number = Math.floor(index/chunkLength)

            if(!resultArray[chunkIndex]) {
                resultArray[chunkIndex] = [] // start a new chunk
            }

            resultArray[chunkIndex].push(item)

            return resultArray
        }, [])
        console.log({arr, chunks})
        return chunks;
    }

}
